import React from "react";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface ITextContentViewProps {
  title: string;
  content: string;
  type?: "original" | "suggested" | "improved";
  isMarkdown?: boolean;
}

/**
 * TEXT CONTENT VIEW COMPONENT
 * @param {ITextContentViewProps} { title, description }
 * @returns
 */
const TextContentView = ({
  title,
  content,
  type = "original",
  isMarkdown = false,
}: ITextContentViewProps): React.ReactNode => {
  return (
    <div>
      <h3 className="font-medium text-xs mb-2 text-gray-500 uppercase">
        {title}
      </h3>

      <div
        className={`p-4 ${type === "original"
            ? "bg-gray-50 rounded-md border-[1px] border-gray-200"
            : "bg-[#F8EEFF] rounded-md"
          }`}
      >
        {isMarkdown ? (
          <div className="markdown-body text-sm">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                p: ({ node: _node, ...props }) => <p {...props} className="mb-2 last:mb-0" />,
                ul: ({ node: _node, ...props }) => <ul {...props} className="list-disc ml-4 mb-2" />,
                ol: ({ node: _node, ...props }) => <ol {...props} className="list-decimal ml-4 mb-2" />,
                a: ({ node: _node, ...props }) => <a {...props} className="text-blue-600 underline" />,
              }}
            >
              {content}
            </ReactMarkdown>
          </div>
        ) : (
          <p className="text-black text-sm font-normal">{content}</p>
        )}
      </div>
    </div>
  );
};

export default TextContentView;
